<div [ngClass]="getColor()">
  <img *ngIf="image" src="{{ image }}" />
  <span>{{ status }}</span>
</div>
